import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=bf37523a&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf37523a')) {
      api.createRecord('bf37523a', component.options)
    } else {
      api.reload('bf37523a', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=bf37523a&", function () {
      api.rerender('bf37523a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zqB9IsqZjVVX/JS/comp/ErrorMessage.vue"
export default component.exports